<div class="content-panel interview-review">

  <div class="row">
    <div class="col-12 col-sm-9">
      @if (new) {
        <h2 translate>SCHEDULE_INTERVIEW.REVIEW.BANNER</h2>
      }
      @if (!new) {
        <h2 translate>SCHEDULE_INTERVIEW.REVIEW.BANNER_RESCHEDULE</h2>
      }
    </div>
    @if (requireReason) {
      <div class="col-12 col-sm-3 pull-right">
        <span class="required">* <span translate>GENERAL_REUSABLE.REQUIRED_FIELD</span></span>
      </div>
    }
  </div>

  <table class="payment-table table table-striped">
    <tbody>
      <tr>
        <td colspan="2" class="title-row" translate>SCHEDULE_INTERVIEW.REVIEW.SUMMARY</td>
      </tr>
      <tr>
        <td translate>SCHEDULE_INTERVIEW.REVIEW.LOCATION</td>
        @if (!isRemoteLocation) {
          <td translate>{{appointmentLocation.name}}</td>
        }
        @if (isRemoteLocation) {
          <td><span translate>SCHEDULE_INTERVIEW.REMOTE_VIA_ZOOM</span></td>
        }
      </tr>
      <tr>
        <td translate>SCHEDULE_INTERVIEW.REVIEW.DATE</td>
        <td><span translate>{{dayOfWeek}}</span>, <span id="monthSpan" translate>{{month}}</span> {{appointmentDate | date: 'dd, y'}}</td>
      </tr>
      <tr>
        <td translate>SCHEDULE_INTERVIEW.REVIEW.TIME</td>
        <td>{{appointmentTime | date: 'shortTime'}} {{appointmentLocation.tzData}} ({{moment.tz(appointmentLocation.tzData).format('z')}})</td>
      </tr>
      <tr>
        <td translate>SCHEDULE_INTERVIEW.REVIEW.FOR</td>
        <td>{{appointmentFor.name}}</td>
      </tr>
    </tbody>
  </table>

  @if (requireReason) {
    <form >
      <label for="reason"><span class="required">*</span> <span translate>GENERAL_REUSABLE.REASON</span></label>
      @if (!isIE) {
        <textarea [value-type]="'textPattern'" class="form-control" rows="3" id="reason" name="reason" [(ngModel)]="reason" maxlength="2000"></textarea>
      }
      @if (isIE) {
        <input id="reason" [value-type]="'textPattern'"  tabindex="0" class="form-control" name="reason" maxlength="2000"  [(ngModel)] = "reason">
      }
    </form>
  }

</div>